import React, { FC } from 'react'
import { Alert, Divider, Typography } from 'antd'
import { WithdrawalEdit } from '../../edit'
import {
  humanWithdrawalRejectionReason,
  transactionRequestStatus,
} from '../../../const'

type TransactionCommentsBlockProps = {
  withdrawal: WithdrawalEdit
}

export const TransactionCommentsBlock: FC<TransactionCommentsBlockProps> = ({
  withdrawal,
}) => {
  if (
    !withdrawal.rejectReason?.length &&
    !withdrawal.psComment &&
    !withdrawal.managerComment &&
    !withdrawal.internalComment
  ) {
    return null
  }

  return (
    <>
      <Divider />
      {withdrawal.rejectReason?.length > 0 && (
        <Alert
          type="error"
          showIcon
          message={
            <span style={{ fontSize: 16, fontWeight: 600 }}>
              {humanWithdrawalRejectionReason(withdrawal.rejectReason)}
            </span>
          }
          style={{ marginBottom: 8 }}
        />
      )}
      {withdrawal.psComment && (
        <div>
          <Typography.Text>PS Comment: </Typography.Text>
          <Typography.Text
            type={
              withdrawal.status === transactionRequestStatus.vendorError()
                ? 'danger'
                : undefined
            }
          >
            {withdrawal.psComment}
          </Typography.Text>
        </div>
      )}
      {withdrawal.managerComment && (
        <div>
          <Typography.Text>
            Manager Comment: {withdrawal.managerComment}
          </Typography.Text>
        </div>
      )}
      {withdrawal.internalComment && (
        <div>
          <Typography.Text>
            Internal Comment: {withdrawal.internalComment}
          </Typography.Text>
        </div>
      )}
    </>
  )
}
